(() => {
  if (window.anthologyGemstoneHelpInstalled) return;
  window.anthologyGemstoneHelpInstalled = true;
  const selector = '[data-gemstone-help]';
  const widgetFor = target => target instanceof Element ? target.closest(selector) : null;
  const show = (widget, open) => {
    const button = widget.querySelector('button');
    const tooltip = widget.querySelector('[role="tooltip"]');
    if (!button || !tooltip) return;
    button.setAttribute('aria-expanded', String(open));
    tooltip.hidden = !open;
  };
  const close = widget => { widget.dataset.pinned = ''; show(widget, false); };
  document.addEventListener('pointerover', event => {
    if (event.pointerType !== 'mouse') return;
    const widget = widgetFor(event.target);
    if (widget && !widget.contains(event.relatedTarget)) show(widget, true);
  });
  document.addEventListener('pointerout', event => {
    if (event.pointerType !== 'mouse') return;
    const widget = widgetFor(event.target);
    if (widget && !widget.contains(event.relatedTarget) && widget.dataset.pinned !== 'true' && !widget.contains(document.activeElement)) show(widget, false);
  });
  document.addEventListener('focusin', event => { const widget = widgetFor(event.target); if (widget) show(widget, true); });
  document.addEventListener('focusout', event => { const widget = widgetFor(event.target); if (widget && !widget.contains(event.relatedTarget) && widget.dataset.pinned !== 'true') show(widget, false); });
  document.addEventListener('click', event => {
    const widget = widgetFor(event.target);
    document.querySelectorAll(selector).forEach(other => { if (other !== widget) close(other); });
    if (!widget || !event.target.closest('button')) return;
    const open = widget.dataset.pinned !== 'true';
    widget.dataset.pinned = open ? 'true' : '';
    show(widget, open);
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll(selector).forEach(close);
  });
})();
